module.exports = __webpack_public_path__ + "static/homepage-background-a179b0ec756ad9e79d978c4e257aab71.png";